var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReapplicatorActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11C11.433 11 13 9.433 13 7.5C13 5.567 11.433 4 9.5 4C7.567 4 6 5.567 6 7.5C6 9.433 7.567 11 9.5 11Z",
    fill: "#FCAD09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.5C6.46243 12.5 4 14.9624 4 18V19.5C4 19.7761 4.22386 20 4.5 20H14.5C14.7761 20 15 19.7761 15 19.5V18C15 14.9624 12.5376 12.5 9.5 12.5Z",
    fill: "#FCAD09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7C19.5 6.72386 19.2761 6.5 19 6.5C18.7239 6.5 18.5 6.72386 18.5 7V9.08579L17.7071 8.29289C17.5118 8.09763 17.1953 8.09763 17 8.29289C16.8047 8.48816 16.8047 8.80474 17 9L18.6464 10.6464C18.8417 10.8417 19.1583 10.8417 19.3536 10.6464L21 9C21.1953 8.80474 21.1953 8.48816 21 8.29289C20.8047 8.09763 20.4882 8.09763 20.2929 8.29289L19.5 9.08579V7Z",
    fill: "#FCAD09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13C17 12.7239 17.2239 12.5 17.5 12.5H19C20.3807 12.5 21.5 13.6193 21.5 15C21.5 16.3807 20.3807 17.5 19 17.5H17.9142L18.7071 18.2929C18.9024 18.4882 18.9024 18.8047 18.7071 19C18.5118 19.1953 18.1953 19.1953 18 19L16.3536 17.3536C16.1583 17.1583 16.1583 16.8417 16.3536 16.6464L18 15C18.1953 14.8047 18.5118 14.8047 18.7071 15C18.9024 15.1953 18.9024 15.5118 18.7071 15.7071L17.9142 16.5H19C19.8284 16.5 20.5 15.8284 20.5 15C20.5 14.1716 19.8284 13.5 19 13.5H17.5C17.2239 13.5 17 13.2761 17 13Z",
    fill: "#FCAD09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReapplicatorActive);
export default __webpack_public_path__ + "static/media/reapplicator_active.4c3cecb31673637bb937e6ded28961c1.svg";
export { ForwardRef as ReactComponent };